var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DialogCheckbox',{attrs:{"data":_vm.data.columns,"dialogIcon":"mdi-table-arrow-down","title":"Kolonner som skal eksporteres"},on:{"action":_vm.exportTable},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }